import { JobScheduleDetails } from "./application-data";

export function getProcessedJCAddress(scheduleDetails: JobScheduleDetails) {
  let address = "";
  if (scheduleDetails?.address) {
    address = scheduleDetails.address;
    if (scheduleDetails.city) {
      address += ", " + scheduleDetails.city;
    }

    if (scheduleDetails.state && scheduleDetails.postalCode) {
      address +=
        ", " + scheduleDetails.state + " " + scheduleDetails.postalCode;
    }
  }
  return address;
}
